import { createContext } from "@-/com.npmjs.use-context-selectors";
import { defaultError } from "@-/com.npmjs.react-context-default-error";
import type {
  WordCharacterBack,
  WordContextSentence,
} from "@-/dev.improve.haniverse.lib.sentence.context";
import type { WordDrillType } from "#drill-branch-types";

/**
 * The word branch of a drill: published by `WordDrillGateSuspense` once it has frozen the sentence
 * that presents this word for the mounted presentation. Only components that belong to a word
 * drill read it (the sentence prompts and the sentence back); a grapheme drill never mounts it.
 */
export type WordDrillContextValue = {
  /** Each character of the word, in order, with its meaning-card back. */
  characterBacks: readonly WordCharacterBack[];
  drillType: WordDrillType;
  /** The sentence presenting this word, frozen for the mounted presentation. */
  sentence: WordContextSentence;
};

export const WordDrillContext = createContext(
  defaultError<WordDrillContextValue>("WordDrillContext"),
);
